export default {
  install(Vue, options)
  {
    // Vue.prototype.IP = 'http://twx.ctb.com/';//本地IP
    // Vue.prototype.IP = 'http://titfc.e-kjt.com/';//測試服務器IP
    // Vue.prototype.IP = 'http://itfc.e-kjt.com/';//生產服務器IP
    // Vue.prototype.IP = process.env.API_ROOT;//環境變量IP

    if(window.location.protocol === 'https:')
    {
      Vue.prototype.IP = process.env.HTTPS_API_ROOT;//生產環境https
    }
    else
    {
      Vue.prototype.IP = process.env.API_ROOT;//測試環境http
    }

    Vue.prototype.PATH = 'api/v1';
    Vue.prototype.imgPath = Vue.prototype.IP + 'ekjt_groupadmin/getmedia?media_id=';
    Vue.prototype.emailPath = 'ekjt_groupadmin/groupsendemail/';//郵件群發
    Vue.prototype.adminEmail = process.env.ADMIN_EMAIL;
    Vue.prototype.version = process.env.VERSION;

    Vue.prototype.getTimestamp = function() { //獲取昨天00:00時間戳
      var todayDate = new Date();
      var timestamp = todayDate.getTime();
      return String(parseInt(timestamp / 1000) - 86400);
    };
    Vue.prototype.reLogin = function(callback)//獲取用戶信息，提供回調
    {
      this.$dialog.loading.open();
      this.axios.post(this.IP + this.PATH + '/getuserinfo').then(response => {
        if(response.data.code === "SUCCESS")
        {
          Vue.prototype.setCookie("admin_name", response.data.responseData.name);//管理員名稱
          Vue.prototype.setCookie("username", response.data.responseData.username)//管理員ID
          if(callback)
          {
            callback();
          }
        }
        this.$dialog.loading.close();
      });
    };
    Vue.prototype.refreshJwt = function() {
      this.$dialog.loading.open();
      if(this.$store.state.token)
      {
        var jwt = this.$store.state.token;
      }
      else if(window.sessionStorage.getItem('token'))
      {
        var jwt = window.sessionStorage.getItem('token');
      }
      this.axios.post(this.IP + 'ekjt_groupadmin/refreshjwt', {
        jwt: jwt
      }).then(response => {
        if(response.data.code == "SUCCESS")
        {
          if(response.data.responseData)
          {
            this.$store.commit('token', response.data.responseData.jwt);
            window.sessionStorage.setItem("token", response.data.responseData.jwt);
          }
        }
        else
        {
          if(response.data.message)
          {
            this.$notify({
              title: '警告', message: response.data.message, type: 'warning'
            });
          }
        }
        this.$dialog.loading.close();
      });
    }
    Vue.prototype.NewDate = function(str) { //解決new Date()IE不支持傳參
      //首先將日期分隔 ，獲取到日期部分 和 時間部分
      var day = str.split(' ');
      //獲取日期部分的年月日
      var days = day[0].split('-');
      //獲取時間部分的 時分秒
      var mi = day[day.length - 1].split(':');
      //獲取當前date類型日期
      var date = new Date();
      //給date賦值  年月日
      date.setUTCFullYear(days[0], days[1] - 1, days[2]);
      //給date賦值 時分秒  首先轉換utc時區 ：+8
      date.setUTCHours(mi[0] - 8, mi[1], mi[2]);
      return date;
    };
    //計算時間差
    Vue.prototype.dateMinus = function(oldDate, newDate) {
      var date1 = new Date(newDate); //開始時間
      var date2 = new Date(oldDate); //結束時間
      var date3 = date1.getTime() - date2.getTime(); //時間差秒
      /*//獲取剩余月份
      var startMonth = date1.getMonth();
      var endMonth = date2.getMonth();
      var months =  (date1.getFullYear()*12+startMonth) - (date2.getFullYear()*12+endMonth);*/
      //計算出相差天數
      if(date3 >= 0)
      {
        var days = Math.floor(date3 / (24 * 3600 * 1000));
      }
      else
      {
        var days = Math.ceil(date3 / (24 * 3600 * 1000));
      }

      //計算出小時數
      var leave1 = date3 % (24 * 3600 * 1000); //計算天數後剩余的毫秒數
      if(leave1 >= 0)
      {
        var hours = Math.floor(leave1 / (3600 * 1000));
      }
      else
      {
        var hours = Math.ceil(leave1 / (3600 * 1000));
      }
      //計算相差分鐘數
      var leave2 = leave1 % (3600 * 1000); //計算小時數後剩余的毫秒數
      if(leave2 >= 0)
      {
        var minutes = Math.floor(leave2 / (60 * 1000));
      }
      else
      {
        var minutes = Math.ceil(leave2 / (60 * 1000));
      }
      //計算相差秒數
      var leave3 = leave2 % (60 * 1000); //計算分鐘數後剩余的毫秒數
      var seconds = Math.round(leave3 / 1000);
      return {
        // months:months,
        days: days, hours: hours, minutes: minutes, seconds: seconds,
      }
    }
    Vue.prototype.setCookie = function(c_name, value, expiredays) { //創建cookie 傳參量名、數據源、到期時間（可以不傳）
      let exdate = new Date()
      exdate.setDate(exdate.getDate() + expiredays)
      document.cookie = c_name + "=" + escape(value) + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString())
    };
    Vue.prototype.delCookie = function(name) {  //清除cookie
      let exp = new Date();
      exp.setTime(exp.getTime() - 1);
      let cval = this.getCookie(name);
      if(cval != null)
      {
        document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
      }
    };
    Vue.prototype.getCookie = function(c_name) { //獲取cookie
      if(document.cookie.length > 0)
      {
        let c_start = document.cookie.indexOf(c_name + "=")
        if(c_start !== -1)
        {
          c_start = c_start + c_name.length + 1
          let c_end = document.cookie.indexOf(";", c_start)
          if(c_end === -1)
          {
            c_end = document.cookie.length
          }
          return unescape(document.cookie.substring(c_start, c_end))
        }
      }
      return ""
    };
    Vue.prototype.data_paging = function(value, page_sum)//整理數據，供element分頁組件使用
    {  //數據分頁展示
      var number = Math.ceil(value.length / page_sum)
      var count = 0;
      var value_array = [];
      for(var s = 0; s < number; s++)
      {
        var arr_i = []
        for(var i = 0; i < page_sum; i++)
        {
          if(!value[count])
          {
            break;
          }
          arr_i.push(value[count])
          count++;
        }
        value_array[s] = arr_i;
      }
      return {
        'da_ta': value_array[0], //第壹頁的數據
        'value_data': value_array, //全部數據
        'total': number * 10  //頁碼
      }
    };
    Vue.prototype.getDatetime = function(to_day)//獲取年月日，時分秒
    { //返回日期與時間
      /*var dateObj = new Date();
       if(to_day instanceof dateObj){
       var todayDate = to_day;
       }
       else {
       var todayDate = new Date(to_day);
       }*/
      var todayDate = new Date(to_day);
      var date = todayDate.getDate();
      if(date < 10)
      {
        date = '0' + date;
      }
      var month = todayDate.getMonth() + 1;
      if(month < 10)
      {
        month = '0' + month;
      }
      var year = todayDate.getYear()
      var week = (1900 + year) + "-" + month + "-" + date;
      var hour = todayDate.getHours();
      if(hour < 10)
      {
        hour = '0' + hour;
      }
      var minutes = todayDate.getMinutes();
      if(minutes < 10)
      {
        minutes = '0' + minutes;
      }
      var seconds = todayDate.getSeconds();
      if(seconds < 10)
      {
        seconds = '0' + seconds;
      }
      var dateTime = week + ' ' + hour + ':' + minutes + ':' + seconds
      return {
        'week': week, 'dateTime': dateTime
      }
    };
    Vue.prototype.lastDay = function(day)//返回day天後的年月日
    { //返回7天後
      var nowDate = new Date();
      return this.getDatetime(nowDate.getTime() - (24 * 60 * 60 * 1000 * day)).week;
    };
    Vue.prototype.getPdf = function(title, dom)//生成PDF
    {
      var beginTime = new Date().getTime();
      console.log('PDF創建');
      this.$dialog.loading.open();
      var that = this;
      var title = title
      var c = document.createElement("canvas")
      var opts = {
        scale: 2, canvas: c, logging: true, width: dom.width, height: dom.height,
      };
      c.width = dom.width * 2
      c.height = dom.height * 2
      c.getContext("2d").scale(2, 2);
      this.html2Canvas(dom, opts).then(function(canvas) {
        let contentWidth = canvas.width
        let contentHeight = canvas.height
        let pageHeight = contentWidth / 592.28 * 841.89
        let leftHeight = contentHeight
        let position = 0
        let imgWidth = 595.28
        let imgHeight = 592.28 / contentWidth * contentHeight
        let pageData = canvas.toDataURL('image/jpeg', 1.0)
        let JsPDF = that.JsPDF;
        let PDF = new JsPDF('', 'pt', 'a4')
        if(leftHeight < pageHeight)
        {
          PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
        }
        else
        {
          while(leftHeight > 0)
          {
            PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
            leftHeight -= pageHeight
            position -= 841.89
            if(leftHeight > 0)
            {
              PDF.addPage()
            }
          }
        }
        PDF.save(title + '.pdf')
        var endTime = new Date().getTime();
        console.log('PDF創建完成，耗時' + (endTime - beginTime) / 1000 + 's');
        that.$dialog.loading.close();
      })
    };
    Vue.prototype.exportPdf = async function(title, dom)//生成PDF
    {
      console.log('創建PDF');
      let beginTime = new Date().getTime();
      this.$dialog.loading.open();
      let that = this;
      // let c = document.createElement("canvas")
      // c.width = dom.width * 2
      // c.height = dom.height * 2
      // c.getContext("2d").scale(2, 2);
      //
      // let opts = {
      //   scale: 2, canvas: c, logging: true, width: dom.width, height: dom.height,
      // };
      // this.html2Canvas(dom, opts).then(function(canvas) {
      // console.log(dom);

      this.html2Canvas(dom).then(function(canvas) {
        let contentWidth = canvas.width
        let contentHeight = canvas.height
        // let pageHeight = contentWidth / 592.28 * 841.89
        // let leftHeight = contentHeight
        // let position = 0
        // let imgWidth = 595.28
        // let imgHeight = 592.28 / contentWidth * contentHeight
        let pageData = canvas.toDataURL('image/jpeg', 1.0)
        //計算pdf高度，按照a4紙的寬高比例計算
        let pdfHeight = Math.min(600 * (canvas.height / canvas.width), 842)
        // console.log(dom.offsetWidth, dom.offsetHeight, canvas.width, canvas.height);
        // console.log(pdfHeight);

        // return
        let JsPDF = that.JsPDF;
        let PDF = new JsPDF('', 'pt', 'a4')
        // PDF.addImage(pageData, 'JPEG', 0, 0, dom.offsetHeight, dom.offsetWidth)
        // PDF.addImage(pageData, 'JPEG', 0, 0, dom.offsetWidth, dom.offsetHeight)
        // PDF.addImage(pageData, 'JPEG', 0, 0, canvas.width, canvas.height)
        // PDF.addImage(pageData, 'JPEG', 0, 0, 100, 50)
        // PDF.addImage(pageData, 'JPEG', 0, 0, 600, 600 * canvas.height / canvas.width)
        PDF.addImage(pageData, 'JPEG', 0, 0, 600, pdfHeight)

        // PDF.addImage(pageData, 'JPEG', 0, 0, 593, pageHeight)
        // if(leftHeight < pageHeight)
        // {
        //   PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
        // }
        // else
        // {
        //   while(leftHeight > 0)
        //   {
        //     PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
        //     leftHeight -= pageHeight
        //     position -= 841.89
        //     if(leftHeight > 0)
        //     {
        //       PDF.addPage()
        //     }
        //   }
        // }
        PDF.save(title + '.pdf')
        let endTime = new Date().getTime();
        console.log('PDF創建完成，耗時' + (endTime - beginTime) / 1000 + 's');
        that.$dialog.loading.close();
      })
    };
    //下劃線轉換駝峰
    Vue.prototype.underlineToHump = (str) => {
      // 如果首字母是_，執行 replace 時會多壹個_，這裏需要去掉
      if(str.slice(0, 1) === '_')
      {
        str = str.slice(1);
      }
      return str.replace(/([^_])(?:_+([^_]))/g, function($0, $1, $2) {
        return $1 + $2.toUpperCase();
      });
    }

    //駝峰轉換下劃線
    Vue.prototype.humpToUnderline = (str) => {
      let temp = str.replace(/[A-Z]/g, function(match) {
        return "_" + match.toLowerCase();
      });
      // 如果首字母是大寫，執行replace時會多壹個_，這裏需要去掉
      if(temp.slice(0, 1) === '_')
      {
        temp = temp.slice(1);
      }
      return temp;
    }
  }
}



// WEBPACK FOOTER //
// ./src/commonality/common.js